import React from "react";
import { AlertCircle, Clock } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const CancelJobDialog = ({ cancelFor, onClose, onConfirm }) => (
  <AlertDialog open={!!cancelFor} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2"><Clock className="h-4 w-4 text-destructive" /> Cancel Job {cancelFor?.job_no}?</AlertDialogTitle>
        <AlertDialogDescription>Any material already issued to the karigar will be reversed back into stock.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Keep Job</AlertDialogCancel>
        <AlertDialogAction className="bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm}>Cancel Job</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const DeleteJobDialog = ({ deleteFor, onClose, onConfirm }) => (
  <AlertDialog open={!!deleteFor} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2"><AlertCircle className="h-4 w-4 text-destructive" /> Delete Job {deleteFor?.job_no}?</AlertDialogTitle>
        <AlertDialogDescription>This permanently removes the job work order and its material trail. This cannot be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Keep Job</AlertDialogCancel>
        <AlertDialogAction data-testid="job-delete-confirm" className="bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm}>Delete Job</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
